import type { HTMLAttributes, ReactNode } from "react";
import Icon from "../Icon/Icon";
import "./Control.css";

export interface ControlProps extends HTMLAttributes<HTMLDivElement> {
  /** grey background, for read-only or locked values */
  disabled?: boolean;
  /** shows a chevron at the end, for selects and dropdowns */
  chevron?: boolean;
  /** md = 52px (default), sm = 44px */
  size?: "sm" | "md";
  children: ReactNode;
}

/**
 * The input box on its own: border, height, radius, focus ring.
 * Put any control inside (native input or select, phone input, date picker,
 * a custom dropdown) and wrap it in <Field> for the label and error.
 * Plain inputs and selects inside get the same text style automatically.
 */
const Control = ({
  disabled = false,
  chevron = false,
  size = "md",
  className = "",
  children,
  ...rest
}: ControlProps) => (
  <div
    className={[
      "ds-control",
      `ds-control--${size}`,
      chevron ? "ds-control--chevron" : "",
      disabled ? "is-disabled" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    {...rest}
  >
    {children}
    {chevron && (
      <span className="ds-control__chevron" aria-hidden="true">
        <Icon name="chevronDown" />
      </span>
    )}
  </div>
);

export default Control;
